<template>
    <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
        <div class="body-wrapper">
                <nav-bar/>
                <b-container class="position-relative strata-table" fluid>
                    <div class="main-panel">
                        <div class="db-content-wrapper">
                            <div class="px-3 sp-header">
                                    <h2 class="head-title st-pl">Strata Plan</h2>

                                <div class="text-right d-inline-flex flex-row-reverse sp-right">
                                    <div class="position-relative f-b add-sp-btn">
                                        <i class="fas fa-search search-icon"></i>
                                            <b-form-input
                                                    class="mb-2 mb-sm-0"
                                                    placeholder=""
                                                    v-model="filterQuery"
                                                    @change="filter(1)"
                                                ></b-form-input>
                                    </div>

                                    <div class="mr-3">
                                        <b-button
                                            class="btn btn-primary"
                                            :to="{
                                                    name: 'strata-plan-edit',
                                                    params: { id: 'new', step: 1 }
                                                }"
                                            variant="primary">Add Strata Plan
                                        </b-button>
                                    </div>
                                </div>
                            </div>

                            <div class="datagrid">
                                <div class="datagrid-header">
                                    <b-form @submit.prevent inline>
                                        <label class="sr-only" for="quoteType">Name</label>
                                        
                                        <label class="sr-only" for="quoteStatus">Status</label>
                                    </b-form>
                                </div>
                                <div class="datagrid-body">
                                    <b-table class="table tabled px-3 text-nowrap"
                                        :busy="this.$root.loading"
                                        :items="tableItems"
                                        :fields="tableFields"
                                        :current-page="currentPage"
                                        :per-page="perPage"
                                        :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc"
                                        :sort-direction="sortDirection"
                                        sort-icon-left
                                        hover
                                        responsive
                                        show-empty
                                    >
                                        <template v-slot:table-busy>
                                            <div class="text-center text-danger my-2">
                                                <b-spinner
                                                    class="align-middle"
                                                    :variant="'primary'"
                                                ></b-spinner>
                                            </div>
                                        </template>

                                        <template v-slot:cell(action)="row">
                                            <router-link
                                                :to="{
                                                    name: 'manager-strataplan-view',
                                                    params: { id: row.item.strata_plan },
                                                }"
                                                >View
                                            </router-link>
                                        </template>
                                        <template #empty class="text-center">
                                                No Data Found
                                            </template>
                                    </b-table>

                                </div>
                                <div class="datagrid-footer" v-if="lastPage > 1">
                                    <b-pagination
                                        pills
                                        align="right"
                                        :total-rows="total"
                                        v-model="currentPage"
                                        :page-count="lastPage"
                                        :per-page="perPage"
                                        hide-goto-end-buttons="true"
                                    ></b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
            <footer-component></footer-component>
                </b-container>

        </div>
    </b-overlay>
</template>

<script>
import NavBar from "../includes/NavBar.vue";
import _ from "lodash";
import moment from "moment";
import FooterComponent from "./../../includes/FooterComponent.vue";
import phoneNoMixin from "../../../../mixins/phoneNoMixin";

export default {
    components: {
        NavBar,
        FooterComponent,
    },
    mixins: [phoneNoMixin],
    data() {
        return {
            currentPage: 1,
            total: 0,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            perPage: 50,
            tableItems: [],
            tableFields: [
                {key: 'Strata_plan_ID', sortable: true},
                {key: 'Strata_company', sortable: true},
                {key: 'Strata_manager', sortable: true},
                {key: 'Building_contact', sortable: true},
                {key: 'Address', sortable: true},
                {key: 'Library', sortable: true},
                {key: 'Action', sortable: true},
                // {key: 'action', sortable: false}
            ],
            filterQuery: "",
            filterQuoteType: "my-quotes",
            filterStatus: "open",
        };
    },
    mounted() {
        //Remove from session
        sessionStorage.removeItem('addStrataPlanFromQuote');
        sessionStorage.removeItem('addStrataPlanFromWorkOrder');
        
        this.filter();
    },
    methods: {
        filter(page = 1) {
            this.$root.$data.bsLoader = true;
            axios
                .post("api/manager/strata-plan/filter", {
                    page: page,
                    filterParams: this.filterParams,
                    filter_query: this.filterQuery,
                })
                .then((response) => {
                    this.currentPage = response.data.current_page;
                    this.total = response.data.total;
                    this.perPage = response.data.per_page;
                    this.tableItems = _.map(response.data.strata_plans, (strata_plan) => {                        
                        return {
                            strata_plan: strata_plan.id,
                            Strata_plan_ID: strata_plan.type+ '-' +strata_plan.strata_plan_number,
                            Strata_company: strata_plan.business.company_name,
                            Strata_manager: strata_plan.manager.first_name + " " + strata_plan.manager.last_name,
                            Building_contact: strata_plan.strata_manager_phone ? this.formatPhoneForAustraliaBySpace(strata_plan.strata_manager_phone) : null,
                            Address: strata_plan.address,
                            // Library: "Documents (" +strata_plan.media.length + ")",
                            action: "",
                        };
                    });
                    this.$root.$data.bsLoader = false;
                }).catch((err) => {
              this.$root.$data.bsLoader = false;
            });
        },
    },
    watch: {
        currentPage: {
            handler: function (value) {
                this.filter(value);
            },
        },
    },
};
</script>

<style scoped>
 .body-wrapper
 {
     background-color: #F7F7FC !important;
     height: 100vh;
 }
 .page-title
 {
     font-size: 28px;
     font-weight: 600;
 }

 .sp-header {
     display: flex;
     justify-content: space-between;
     align-items: center;
     flex-wrap: wrap;
     gap: 10px;
 }

 footer {
     margin-top: 9rem;
     margin-bottom: 1rem;
 }

 @media screen and (max-width: 639px) {
     .sp-right {
         flex-wrap: wrap;
         justify-content: flex-end;
         gap: 10px;
     }

     .add-sp-btn {
         width: 100%;
     }
 }
</style>
